export default __webpack_public_path__ + "f5deecb3c14f4976ab501a877ad63254.svg";